import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "BaseSidePanel flex column no-wrap bg-off-white-10 q-px-sm" }


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'BaseSidePanel' },
  __name: 'BaseSidePanel',
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "header"),
    _renderSlot(_ctx.$slots, "body")
  ]))
}
}

})